module.exports = __webpack_public_path__ + "static/media/dropdown-arrow-black.e70fe1ff.svg";